import { useStaticListSource } from '@eas/common-web';
import { NonStandardStateLevel, Severity } from '@enums';
import { NonStandardState } from '@models';

export function useNonStandardStateLevels() {
  return useStaticListSource<NonStandardState>([
    { id: NonStandardStateLevel.DOCUMENT, name: 'Dokument' },
    { id: NonStandardStateLevel.BATCH, name: 'Dávka' },
    { id: NonStandardStateLevel.REQUEST, name: 'Požadavek' },
  ]);
}

export function useSeverity() {
  return useStaticListSource<NonStandardState>([
    { id: Severity.GARBAGE, name: 'Odpad' },
    { id: Severity.WARN, name: 'Varování' },
    { id: Severity.INFO, name: 'Informace' },
    { id: Severity.ERROR, name: 'Chyba' },
  ]);
}
